import React from "react";
import Cookies from 'universal-cookie'
import { Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap";
import { UserObjectStoreProvider, SaveItem, getUserobjectData, isAuthenticated, savedSearchParams } from "@starberry/myaccount-website-utils";

import { ShowProcessedImage } from "../../common/stb-jamstack-ggfxclient/module/components/image/show-image";
import imageConfig from "../../../../static/images/config.json"
import GetBranch from "../../get-branch";
import Soon from "../../../../src/images/coming-soon.jpg";

const mycookies = new Cookies();
const updateAfter = 500

// Property results loop
const InfiniteHits = ({
  hits,
  hasPrevious,
  refinePrevious,
  hasMore,
  refineNext,
  location,
  tag,
  userObjects
}) => (
  <>
    {(hits.length > 0 && hasPrevious) && (
      <button
        id="myprevbut"
        onClick={refinePrevious}
        disabled={!hasPrevious}
        className="d-none property_show_more_btn"
      >
        Show prev
      </button>
    )}

    {
      hits.length > 0 && hits.map((hit, i) => {

        // property details url structure
        let uriStr = "";
        let mysale = "";
        let aftprc = "";
        if (hit.searchType === "sales" && hit.department === 'residential') {
          uriStr = `property-for-sale/`
          mysale = `myResSaleProp`
        } else if (hit.searchType === "lettings" && hit.department === 'residential') {
          uriStr = `property-to-rent/`
          mysale = `myResRentProp`
          aftprc=` pcm`;
        }
        else if (hit.searchType === "sales" && hit.department === 'new_developments') {
          uriStr = `new-home-for-sale/`
          mysale = `myNewHomeProp`                      
        }
        else if (hit.searchType === "lettings" && hit.department === 'new_developments') {
          uriStr = `new-home-to-rent/`;
          mysale = `myNewHomeLettingProp`;
        }
        // property details url structure

        let property_id = (hit?.objectID || hit?.id);

        return (
          <>
            {
              <UserObjectStoreProvider>
              <Container id={`${mysale}${hit.objectID}`} key={i}>
                
                <div className="search-item-box">
                    <Row>
                    <Col md={12} className="d-lg-flex">
                        <div className="search-property-img img-zoom">
                        
                          <Link onClick={() => mycookies.set(mysale, property_id, { path: '/', maxAge: 300 })}
                              to={`/${uriStr}${hit.slug}-${property_id}/`}
                              propID={property_id}
                              className="img-zoom"
                          >
                            {hit?.images?.length > 0 &&
                              hit.images?.map((image, i) => {
                                return (
                                  <ShowProcessedImage images={image} attr={{ className: 'mb-0 img-fluid', alt: 'Property Listing - '+hit.display_address+' -  Balgores'}} transforms={imageConfig.property.searchResults.sizes} /> 
                                )
                              })
                            }  
                            {(!hit.images || hit.images.length === 0) &&
                              <div className="no-img img-zoom">
                                <img src={Soon} className='mb-0 img-fluid' alt="" />
                              </div>            
                            }
                        
                        </Link>
                        <span className="property-tag">
                        {hit.status}
                        </span>
                        </div>
                        <div className="search-property-details">
                        <SaveItem type="property" pid={property_id} userObjects={userObjects} >
                          <div className="like-btn">
                              <i className="icon-heart-outline"></i>
                          </div>
                        </SaveItem>
                        <h2>
                            <Link to={`/${uriStr}${hit.slug}-${property_id}/`}>{hit.display_address}</Link>
                        </h2>
                        <span className="search-property-text">{hit.title}</span>
                        {hit.price_qualifier !== "Price On Application" ? <span className="property-price">£{hit.price.toLocaleString()}<span>{aftprc}</span></span> : <span className="price-on-application">Price On Application</span> }
                        {/* <span className="property-price">£{hit.price.toLocaleString()}<span>{aftprc}</span></span> */}
                        <div className="property-description">
                            <p>{hit.description.slice(0,200)}</p>
                        </div>
                            <GetBranch officecrm={hit.office_crm_id} searchtype={hit.searchType} />
                            <div className="btn-view">
                                <a href={`/${uriStr}${hit.slug}-${property_id}/`} className="btn">View Details</a>
                                <Link to={`/book-a-viewing?pid=${property_id}`} className="book-text"><i className="icon-calendar"></i> Book a viewing</Link>
                            </div>
                        </div>
                    </Col>
                    </Row>
                </div>
                
                
              </Container> 
              </UserObjectStoreProvider>
            }
            {
              ((i + 1) % 5) === 0 ?
              <Container> 
                <Row>
                  <Col md="12">
                    <div className="appraisal-bar">
                      <div className="left-block">
                        <h2>How much is your property worth?</h2>
                        <p>
                          Book a free valuation appointment with one of our
                          experts.
                        </p>
                      </div>
                      <div className="right-block">
                        <Link to="/property-valuation/" className="btn">
                          Book your market appraisal
                        </Link>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
              : ''
            }
          </>
        )
      })}

      {(hits.length > 0 && hasMore) && (
          <Container>
              <button
                  id="mynextbut"
                  onClick={refineNext}
                  disabled={!hasMore}
                  className="btn load-view"
              >
              Load More Properties
              </button>
          </Container>
      )}
  </>
)


export default InfiniteHits;
